import {Injectable} from '@angular/core';
import {BackendService} from './general/backend.service';
import {BehaviorSubject, Observable, Subscription, timer, map} from 'rxjs';
import {BedrockProcess} from './BedrockProcess';
import {switchMap, takeWhile} from 'rxjs/operators';
import {GradeRevision, CreateGradeRevisionWithAIRequest} from '../models/grade.models';

@Injectable({
  providedIn: 'root',
})
export class AiService {
  constructor(private backend: BackendService) {
  }

  private processStatusSubject = new BehaviorSubject<BedrockProcess | null>(null);
  public processStatus$ = this.processStatusSubject.asObservable();
  private pollingSubscription?: Subscription;


  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public generateMagicWriterResponse(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/generate-magic-writer-response', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public generateSummarySingleQ(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/generate-summary-single-question', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public surveyQuestionAIAnalisys(
    question_id: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.get(`ai/ai-analysis/survey/question/${question_id}`).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * Recupera l'analisi AI di una domanda
   * @param question_id
   * @param success_callback
   * @param error_callback
   */
  public getQuestionAiAnalysis(
    question_id: number,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    this.backend.get(`surveys/question/${question_id}/ai-analysis`).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        error_callback(error);
      }
    );
  }

  /**
   * Triggera l'elaborazione dell'analisi AI per una domanda di una survey
   * @param survey_id
   * @param question_id
   * @param survey_attachments - Allegati della survey
   * @param question_attachments - Allegati della domanda
   * @param survey_llm_analysis - LLM analysis for survey-level attachments
   * @param question_llm_analysis - LLM analysis for question-level attachments
   * @param answer_llm_analysis - LLM analysis for answer-level attachments
   * @param success_callback
   * @param error_callback
   */
  public triggerSurveyAiAnalysis(
    survey_id: number,
    question_id: number,
    survey_attachments: any[] = [],
    question_attachments: any[] = [],
    survey_llm_analysis: any[] = [],
    question_llm_analysis: any[] = [],
    answer_llm_analysis: any[] = [],
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    const payload = {
      question_id,
      survey_attachments,
      question_attachments,
      survey_llm_analysis,
      question_llm_analysis,
      answer_llm_analysis
    };

    this.backend.post(`surveys/${survey_id}/trigger-ai-analysis`, payload).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }


  public textTranslateResponse(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/text-translate', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public dashboardExplanation(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/dashboard-explanation', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public generateKeywordsResponse(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/generate-keywords-response', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public generatePICOResponse(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/generate-pico-response', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * invia richiesta al modello AI
   * @param model
   * @param success_callback
   * @param error_callback
   */
  public generateLiteratireReviewTableWithPubmedArticles(
    model: any,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/generate-literature-ai-response', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  getPicoGradeProcessStatus(processId: number): Observable<BedrockProcess> {
    return this.backend.get(`ai/generate-literature-ai-response/status/${processId}`).pipe(
      map((response: any): BedrockProcess => {
        return {
          id: response.id,
          status: response.status,
          message: response.message,
          result: response.result,
          created_at: response.created_at,
          updated_at: response.updated_at
        };
      })
    );
  }

  startPolling(processId: number, intervalMs: number = 5000) {
    this.stopPolling();

    this.pollingSubscription = timer(0, intervalMs).pipe(
      switchMap(() => this.getPicoGradeProcessStatus(processId)),
      takeWhile((response: BedrockProcess) =>
          response.status !== 'completed' &&
          response.status !== 'failed',
        true
      )
    ).subscribe(
      (process) => {
        this.processStatusSubject.next(process);
        if (process.status === 'completed' || process.status === 'failed') {
          this.stopPolling();
        }
      },
      (error) => {
        console.error('Error polling process status:', error);
        this.stopPolling();
      }
    );
  }

  stopPolling() {
    if (this.pollingSubscription) {
      this.pollingSubscription.unsubscribe();
      this.pollingSubscription = undefined;
    }
  }

  // Enhanced Grade AI Integration
  createGradeRevisionWithAI(
    model: CreateGradeRevisionWithAIRequest,
    success_callback = (data: { revision: GradeRevision, process_id: number }) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.post('ai/create-grade-revision-with-ai', model).subscribe(
      (result: any) => {
        success_callback(result as { revision: GradeRevision, process_id: number });
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  getGradeRevisionFromProcess(
    processId: number,
    success_callback = (data: GradeRevision) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    this.backend.get(`ai/process/${processId}/grade-revision`).subscribe(
      (result: any) => {
        success_callback(result as GradeRevision);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  // Enhanced legacy method with grade revision support
  public generateLiteratireReviewTableWithPubmedArticlesEnhanced(
    model: any,
    saveToProject: boolean = false,
    success_callback = (data: any) => {
    },
    error_callback = (error: any) => {
    }
  ) {
    // Add flag to indicate if we want to save as grade revision
    const enhancedModel = {
      ...model,
      save_as_grade_revision: saveToProject
    };

    this.backend.post('ai/generate-literature-ai-response', enhancedModel).subscribe(
      (result: any) => {

        if (result && result.process_id) {
        } else {
          console.warn('No process_id in response - this might be an issue');
        }
        success_callback(result);
      },
      (error) => {
        console.error('AI Service: Backend request failed:', error);
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * Process literature review with AI analysis
   * @param model - Contains organization_id, project_id, and files array
   * @param success_callback
   * @param error_callback
   */
  public processLiteratureReview(
    model: any,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    this.backend.post('ai/ai-analysis/process-literature-review', model).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * Check literature review processing status
   * @param projectId - Project ID
   * @param success_callback
   * @param error_callback
   */
  public checkLiteratureStatus(
    projectId: number,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    console.log('Checking processing status for attachments:', projectId);
    this.backend.get(`ai/ai-analysis/process-literature-status/${projectId}`).subscribe(
      (result) => {
        console.log('Processing status response:', result);
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * Save PubMed article as project document
   * @param organizationId - Organization ID
   * @param projectId - Project ID
   * @param pubmedData - PubMed article data
   * @param success_callback
   * @param error_callback
   */
  public savePubmedDocument(
    organizationId: number,
    projectId: number,
    pubmedData: any,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    const payload = {
      type: 'pubmed',
      PMID: pubmedData.PMID,
      title: pubmedData.ArticleTitle || pubmedData.title,
      link: pubmedData.link,
      doi: pubmedData.Doid || pubmedData.DOI || pubmedData.doi || null,
      authors: pubmedData.Authors || pubmedData.authors || null,
      year: pubmedData.PubYear || pubmedData.year || null,
      abstract: pubmedData.Abstract || pubmedData.abstract || null,
      organization_id: organizationId,
      project_id: projectId
    };


    this.backend.post(`project/${projectId}/pubmed-documents`, payload).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log(error);
        this.backend.showErrors(error);
        error_callback(error);
      }
    );
  }

  /**
   * Get full LLM analysis for a specific attachment
   * @param projectId - Project ID
   * @param attachmentId - Attachment ID
   * @param success_callback
   * @param error_callback
   */
  public getAttachmentAnalysis(
    projectId: number,
    attachmentId: number,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    this.backend.get(`project/${projectId}/attachments/${attachmentId}/analysis`).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        console.log('Error fetching attachment analysis:', error);
        error_callback(error);
      }
    );
  }

  /**
   * Delete a file attachment from a project (and its LLM analysis record)
   */
  public deleteFileAttachment(
    projectId: number,
    attachmentId: number,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    this.backend.destroy(`projects/${projectId}/file-attachments/${attachmentId}`).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        error_callback(error);
      }
    );
  }

  /**
   * Delete a PubMed attachment from a project (and its LLM analysis record)
   */
  public deletePubmedAttachment(
    projectId: number,
    attachmentId: number,
    success_callback = (data: any) => {},
    error_callback = (error: any) => {}
  ) {
    this.backend.destroy(`projects/${projectId}/pubmed-attachments/${attachmentId}`).subscribe(
      (result) => {
        success_callback(result);
      },
      (error) => {
        error_callback(error);
      }
    );
  }

  ngOnDestroy() {
    this.stopPolling();
  }
}
